exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-dashboard-center {\n  padding: 18px;\n  text-align: center; }\n\n.div-grouplist {\n  padding: 2px;\n  text-align: left; }\n\n.p5 {\n  padding: 5px; }\n\n.div-export {\n  text-align: left;\n  padding-top: 15px;\n  padding-bottom: 1px; }\n\n.example-section {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 40px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n\n.example-margin {\n  margin: 0 1px;\n  padding-right: 20px; }\n\n.mt-30 {\n  margin-top: 30px; }\n\n.mt-15 {\n  margin-top: 15px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/export/dashboardschedule/dashboard-schedule-dialog.component.scss
// module id = ../../../../../src/app/shared/export/dashboardschedule/dashboard-schedule-dialog.component.scss
// module chunks = main